// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__glwrk","transparent":"Overlay_transparent__wvnjs","opaque":"Overlay_opaque__5GKxv","empty":"Overlay_empty__Zf56j","loading":"Overlay_loading__ln1lh"};